import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { apiPostClientSignup } from '../../api/api';

export interface ClientSignupState {
  status: 'idle' | 'loading' | 'success' | 'failed';
}

const initialState: ClientSignupState = {
  status: 'idle',
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const postClientSignupAsync = createAsyncThunk(
  'clientSignup/apiPostClientSignup',
  async (request: { email: String; interests: {}}) => {
    const response = await apiPostClientSignup(request);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const clientSignupSlice = createSlice({
  name: 'clientSignup',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStatus: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.status = 'idle';
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(postClientSignupAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postClientSignupAsync.fulfilled, (state, action) => {
        // When the status field of the server response is 400
        // there was an error with the subscription request
        if(action.payload.status != null || action.payload.status !== 400) {
          state.status = 'success';
        } else {
          state.status = 'failed';
        }
      })
      .addCase(postClientSignupAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { clearStatus } = clientSignupSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectClientSignupStatus = (state: RootState) => state.clientSignup.status;

export default clientSignupSlice.reducer;